import { PositionType } from "../../../entities/position";
import PositionRepository from "../../ports/positionRepository";

export type addPositionUseCase = (position: PositionType) => Promise<any>

export const buildAddPosition = (dependencies: {
  positionRepo: PositionRepository
}): addPositionUseCase => {
  const { positionRepo } = dependencies;

  const addPosition: addPositionUseCase = async (position: PositionType) =>
    positionRepo.addPosition(position);

  return addPosition;
}